import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

import Header from './components/Header';
import Dashboard from './components/Dashboard';
import Profile from './components/Profile';
import Members from './components/Members';
import Seats from './components/Seats';
import Admin from './components/Admin';

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      region: 'us-east-1'
    }
  },
  API: {
    REST: {
      'navy-football-api': {
        endpoint: process.env.REACT_APP_API_ENDPOINT,
        region: 'us-east-1'
      }
    }
  }
});

function App() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode) {
      setDarkMode(JSON.parse(savedMode));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  return (
    <div className={darkMode ? 'dark' : ''}>
      <Authenticator>
        {({ signOut, user }) => (
          <Router>
            <div className="min-h-screen bg-white dark:bg-gray-900">
              <Header 
                user={user} 
                signOut={signOut} 
                darkMode={darkMode} 
                setDarkMode={setDarkMode} 
              />
              <main className="container mx-auto px-4 py-8">
                <Routes>
                  <Route path="/" element={<Dashboard user={user} />} />
                  <Route path="/profile" element={<Profile user={user} />} />
                  <Route path="/members" element={<Members user={user} />} />
                  <Route path="/seats" element={<Seats user={user} />} />
                  <Route path="/admin" element={<Admin user={user} />} />
                  <Route path="*" element={<Navigate to="/" />} />
                </Routes>
              </main>
            </div>
          </Router>
        )}
      </Authenticator>
    </div>
  );
}

export default App;